import { render, staticRenderFns } from "./disclamer-remplacement.vue?vue&type=template&id=26da0879"
import script from "./disclamer-remplacement.vue?vue&type=script&setup=true&lang=js"
export * from "./disclamer-remplacement.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports